import { render, staticRenderFns } from "./OperateSecurityIframe.vue?vue&type=template&id=0c361f1b&"
import script from "./OperateSecurityIframe.vue?vue&type=script&lang=ts&"
export * from "./OperateSecurityIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports